export default "__VITE_ASSET__b4fe803e__"